// extracted by mini-css-extract-plugin
export default {"formWrapper":"appSumoRegistration_formWrapper__DetV5","email":"appSumoRegistration_email__EqqF7","passwordHint":"appSumoRegistration_passwordHint__Lz3D+"};